/**
 * 저장소 지도 — 워크스페이스 루트 `CLAUDE.md`·`SERVICE_MAP.md`와 각 repo의 `package.json`·`.nvmrc` 실측.
 * 로컬 실행 명령·포트는 실제 스크립트에서 가져온 것이라, 스크립트가 바뀌면 여기도 같이 고친다.
 */
export type RepoRole = 'backend' | 'frontend' | 'ops' | 'app';

export interface Repo {
  name: string;
  role: RepoRole;
  summary: string;
  stack: string;
  /** `.nvmrc` 기준. 레포마다 다르므로 디렉토리를 옮길 때 `nvm use`를 다시 한다. */
  node?: string;
  /** 로컬 기동 명령. 없으면 아직 정리되지 않았거나 로컬 실행이 필요 없는 저장소. */
  run?: string;
  port?: string;
  /** 신규 입사자가 이 저장소를 언제 처음 열게 되는가 — 읽는 순서를 정하는 힌트. */
  firstTouch?: string;
}

export const REPO_ORG_URL = 'https://github.com/NDMARKET';

export const REPOS: Repo[] = [
  {
    name: 'nd-market-api',
    role: 'backend',
    summary: '메인 B2B 도매/소매 API입니다. 주문·상품·광고·정산이 모두 여기 있는, 워크스페이스의 중심입니다',
    stack: 'Express + TypeScript + Sequelize + MySQL',
    node: 'v24.18.0',
    run: 'npm run start:local',
    port: '3000',
    firstTouch: '대부분의 기능 작업이 여기서 시작됩니다. 컨벤션 문서를 먼저 읽어 주세요',
  },
  {
    name: 'vue_retail',
    role: 'frontend',
    summary: '소매·도매 웹(ceo.ndmarket.co.kr)입니다. `/m/*`가 모바일 웹입니다',
    stack: 'Vue 3 + Vite + Pinia + Naive UI',
    node: 'v24.18.0',
    run: 'npm run dev',
    port: '4000',
    firstTouch: 'API 변경이 화면에 어떻게 닿는지 확인할 때 엽니다',
  },
  {
    name: 'vue_admin',
    role: 'frontend',
    summary: '운영팀 어드민입니다. 상품·주문·광고·정산을 관리하는 화면입니다',
    stack: 'Vue',
    firstTouch: '운영 요청이 들어오는 화면이라 도메인을 빠르게 이해하기 좋습니다',
  },
  {
    name: 'nd-es-bridge',
    role: 'backend',
    summary: '검색 색인·조회 브릿지입니다. 상품 검색과 랭킹이 여기를 지납니다',
    stack: 'NestJS + Elasticsearch',
    node: 'v22.19.0',
    run: 'npm run start:local',
    firstTouch: '검색·랭킹·광고 노출 작업 때 엽니다 — nd-market-api와 양방향으로 함께 봐 주세요',
  },
  {
    name: 'nd-welfare-api',
    role: 'backend',
    summary: '복지몰(careonplus) API입니다. 멀티테넌트이고 DB가 남도마켓과 분리돼 있습니다',
    stack: 'NestJS + TypeORM + PostgreSQL',
    node: 'v22.1.0',
    run: 'npm run start:dev',
    firstTouch: '복지몰 과제를 받을 때 엽니다. 남도마켓 코드를 그대로 옮기면 안 됩니다',
  },
  {
    name: 'parcel-tracker',
    role: 'backend',
    summary: '배송 추적(SweetTracker 연동) 서비스입니다. RabbitMQ로 이벤트를 받습니다',
    stack: 'NestJS + RabbitMQ + Redis',
    node: 'v22.1.0',
    run: 'npm run start:dev',
  },
  {
    name: 'nd-developer-console',
    role: 'ops',
    summary: '지금 보고 계신 개발팀 내부 어드민입니다. 하네스 보드·서비스맵·이 온보딩 가이드가 있습니다',
    stack: 'React + Vite + NestJS + MySQL',
    node: 'v22',
    run: 'npm run dev:web',
    port: '4700 (web) · 4701 (api)',
    firstTouch: '첫날 — 링크와 체크리스트를 여기서 확인합니다',
  },
  {
    name: 'nd-k8s-manifests',
    role: 'ops',
    summary: 'GKE 배포 매니페스트 정본입니다. ArgoCD가 이 저장소를 따라갑니다',
    stack: 'Kustomize + ArgoCD',
    firstTouch: '배포 설정·환경변수·리소스를 바꿔야 할 때 엽니다',
  },
  {
    name: 'market-rn',
    role: 'app',
    summary: '모바일 웹(m.ndmarket.co.kr)을 감싼 하이브리드 WebView 앱입니다',
    stack: 'Expo + React Native',
    firstTouch: '앱 전용 브리지가 얽힌 화면을 작업할 때 엽니다',
  },
];
